(function () {
  // einmal starten, und auch bei Section-Reloads im Editor erneut
  function initTicker(root) {
    const wrap = root || document;
    const tickers = wrap.querySelectorAll('.aa-announcement');
    if (!tickers.length) return;

    tickers.forEach((el) => {
      // doppelte Init verhindern
      if (el.__aaInit) return;
      el.__aaInit = true;

      const slot = el.querySelector('.aa-announcement__slot');
      const itemsWrap = el.querySelector('.aa-announcement__items');
      if (!slot || !itemsWrap) return;

      const items = Array.from(itemsWrap.querySelectorAll('.aa-announcement__item'))
        .map((n) => n.textContent.trim())
        .filter(Boolean);

      if (!items.length) return;

      // Daten aus dem DOM
      let speedMs = parseInt(el.getAttribute('data-speed') || '10000', 10); // Fallback 10s
      if (isNaN(speedMs) || speedMs < 1000) speedMs = 5000;
      const pauseOnHover = el.getAttribute('data-pause') === 'true';

      let index = 0;
      let timer = null;
      let paused = false;

      function render() {
        slot.textContent = items[index];
      }
      function next() {
        index = (index + 1) % items.length;
        render();
      }
      function start() {
        stop();
        timer = setInterval(next, speedMs);
      }
      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      // erste Anzeige, dann starten
      render();
      start();

      if (pauseOnHover) {
        el.addEventListener('mouseenter', () => { paused = true; stop(); });
        el.addEventListener('mouseleave', () => { if (paused) { paused = false; start(); } });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTicker();

    // im Theme-Editor: neu laden, wenn Section neu gerendert wird
    document.addEventListener('shopify:section:load', function (evt) {
      const container = evt.target || evt.detail?.sectionElement;
      if (container) initTicker(container);
    });
  });
})();
